/* Wellness Vision v8 add-on: online purchase for the products mapped in "WV · Compra online" on the homepage,
   and the cart for the Tienda page (same #wv-home wrapper). Uses the Shopify AJAX cart; checkout stays on Shopify. */
(function () {
  'use strict';

  var root = document.getElementById('wv-home');
  if (!root) return;

  var mock = window.WV_SHOP_MOCK || null;
  var dataEl = document.getElementById('wv-shop-data');
  var data = mock || (dataEl ? JSON.parse(dataEl.textContent) : null);
  if (!data) return;

  var products = data.products || {};
  var base = (data.root || '/').replace(/\/?$/, '/');
  function moneyFmt() {
    var lang = window.WV_I18N ? window.WV_I18N.getLang() : 'es';
    return new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'es-ES', { style: 'currency', currency: data.currency || 'EUR' });
  }
  var fmt = function (cents) { return moneyFmt().format(cents / 100); };
  function variantLine(title) {
    if (!title || title === 'Default Title') return '';
    var t = window.WV_I18N ? window.WV_I18N.translateText(title, window.WV_I18N.getLang()) : title;
    return esc(t);
  }
  var byHandle = {};
  Object.keys(products).forEach(function (id) { byHandle[products[id].handle] = id; });

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function L(es, en) {
    return window.WV_I18N && window.WV_I18N.getLang() === 'en' ? en : es;
  }

  function readJson(res) {
    return res.json().then(function (body) {
      if (!res.ok) throw new Error(body.description || body.message || 'Error');
      return body;
    });
  }
  function post(path, body) {
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(readJson);
  }

  var api = mock ? mockApi() : {
    get: function () { return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(readJson); },
    add: function (variantId, quantity) { return post('cart/add.js', { items: [{ id: variantId, quantity: quantity }] }); },
    change: function (key, quantity) { return post('cart/change.js', { id: key, quantity: quantity }); }
  };

  // Local preview only (?shopmock=1): an in-memory cart shaped like Shopify's /cart.js.
  function mockApi() {
    var lines = [];
    function cart() {
      var items = lines.map(function (l) {
        return { key: String(l.variantId), product_title: l.title, variant_title: l.variantTitle || null, quantity: l.quantity, final_line_price: l.price * l.quantity, image: l.image || null };
      });
      return Promise.resolve({
        items: items,
        item_count: items.reduce(function (n, i) { return n + i.quantity; }, 0),
        total_price: items.reduce(function (n, i) { return n + i.final_line_price; }, 0)
      });
    }
    return {
      get: cart,
      add: function (variantId, quantity, meta) {
        var line = lines.find(function (l) { return l.variantId === variantId; });
        if (line) { line.quantity += quantity; return cart(); }
        var id = Object.keys(products).find(function (k) { return products[k].variantId === variantId; });
        var p = id ? products[id] : (meta || {});
        lines.push({ variantId: variantId, quantity: quantity, title: p.title, variantTitle: p.variantTitle, price: p.price || 0, image: p.image });
        return cart();
      },
      change: function (key, quantity) {
        lines = lines.map(function (l) { return String(l.variantId) === key ? Object.assign({}, l, { quantity: quantity }) : l; })
          .filter(function (l) { return l.quantity > 0; });
        return cart();
      }
    };
  }

  // Cart drawer
  var drawer = document.createElement('dialog');
  drawer.className = 'wv-cart';
  drawer.setAttribute('aria-labelledby', 'wv-cart-title');
  drawer.innerHTML =
    '<button type="button" class="dialog-close" data-wv-cart-close>×</button>' +
    '<span class="eyebrow"></span>' +
    '<h2 id="wv-cart-title"></h2>' +
    '<div class="wv-cart-items" aria-live="polite"></div>' +
    '<div class="wv-cart-footer">' +
      '<div class="wv-cart-total"><span></span><strong data-wv-cart-total></strong></div>' +
      '<p class="wv-cart-note"></p>' +
      '<a class="button dark wv-cart-checkout" href="' + esc(base) + 'checkout"></a>' +
    '</div>';
  root.appendChild(drawer);

  function syncCartChrome() {
    var closeBtn = $('[data-wv-cart-close]', drawer);
    if (closeBtn) closeBtn.setAttribute('aria-label', L('Cerrar carrito', 'Close cart'));
    var eyebrow = $('.eyebrow', drawer);
    if (eyebrow) eyebrow.textContent = L('COMPRA ONLINE', 'BUY ONLINE');
    var title = $('#wv-cart-title', drawer);
    if (title) title.textContent = L('Tu carrito', 'Your cart');
    var sub = $('.wv-cart-total span', drawer);
    if (sub) sub.textContent = L('Subtotal', 'Subtotal');
    var note = $('.wv-cart-note', drawer);
    if (note) note.textContent = L('Impuestos y envío se calculan al finalizar la compra.', 'Taxes and shipping are calculated at checkout.');
    var checkout = $('.wv-cart-checkout', drawer);
    if (checkout) checkout.innerHTML = L('Finalizar compra', 'Checkout') + ' <span>↗</span>';
  }
  syncCartChrome();
  window.addEventListener('wv-language-change', function () {
    syncCartChrome();
    refresh();
    if (window.WV_I18N) window.WV_I18N.applyNative(root);
  });

  var cartLink = $$('.header a', root).find(function (a) { return /\/cart\/?$/.test(a.getAttribute('href') || ''); });
  var countEl = null;
  if (cartLink) {
    countEl = document.createElement('span');
    countEl.className = 'wv-cart-count';
    countEl.hidden = true;
    cartLink.appendChild(countEl);
    cartLink.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  }

  function renderCart(cart) {
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.hidden = cart.item_count === 0;
    }
    $('[data-wv-cart-total]', drawer).textContent = fmt(cart.total_price);
    $('.wv-cart-footer', drawer).hidden = cart.item_count === 0;
    $('.wv-cart-items', drawer).innerHTML = cart.items.length
      ? cart.items.map(function (item) {
          return '<div class="wv-cart-line" data-key="' + esc(item.key) + '">' +
            (item.image ? '<img src="' + esc(item.image) + '" alt="" width="72" height="72">' : '<span class="wv-cart-thumb"></span>') +
            '<div><strong>' + esc(item.product_title) + '</strong>' +
              (item.variant_title ? '<small>' + variantLine(item.variant_title) + '</small>' : '') +
              '<div class="wv-cart-qty">' +
                '<button type="button" data-wv-qty="-1" aria-label="' + esc(L('Quitar uno', 'Remove one')) + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-wv-qty="1" aria-label="' + esc(L('Añadir uno', 'Add one')) + '">+</button>' +
                '<button type="button" class="wv-cart-remove" data-wv-qty="remove">' + esc(L('Eliminar', 'Remove')) + '</button>' +
              '</div></div>' +
            '<span class="wv-cart-price">' + fmt(item.final_line_price) + '</span></div>';
        }).join('')
      : '<p class="wv-cart-empty">' + esc(L('Tu carrito está vacío. Los productos con compra online muestran el botón «Comprar».', 'Your cart is empty. Online products show the Buy button.')) + '</p>';
    return cart;
  }

  function refresh() { return api.get().then(renderCart).catch(function () {}); }
  function openCart() {
    refresh();
    if (!drawer.open) drawer.showModal();
  }

  drawer.addEventListener('click', function (e) {
    if (e.target === drawer || e.target.closest('[data-wv-cart-close]')) { drawer.close(); return; }
    var btn = e.target.closest('[data-wv-qty]');
    if (!btn) return;
    var line = btn.closest('.wv-cart-line');
    var current = Number($('.wv-cart-qty span', line).textContent);
    var step = btn.dataset.wvQty;
    var next = step === 'remove' ? 0 : Math.max(0, current + Number(step));
    btn.disabled = true;
    api.change(line.dataset.key, next).then(renderCart).catch(refresh);
  });

  // Shared with the Tienda page (wv8-tienda.js), which adds any variant of any Shopify product.
  window.WVShop = {
    add: function (variantId, quantity, meta) { return api.add(variantId, quantity || 1, meta).then(function () { return api.get(); }).then(renderCart); },
    open: openCart,
    refresh: refresh,
    format: fmt
  };

  // "Comprar" buttons on cards and in the product dialog
  function buyLabel(p) { return p.available ? 'Comprar · ' + fmt(p.price) : 'Agotado'; }

  function decorateCards() {
    $$('[data-product-card]', root).forEach(function (card) {
      var p = products[card.dataset.productCard];
      if (!p || $('.wv-buy', card)) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wv-buy wv-buy-card';
      btn.dataset.wvBuy = card.dataset.productCard;
      btn.disabled = !p.available;
      btn.textContent = buyLabel(p);
      card.appendChild(btn);
    });
  }

  var lastOpened = null;
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-open-product]');
    if (opener) lastOpened = opener.dataset.openProduct;
  }, true);

  function decorateDialog() {
    var info = $('#product-detail-content .detail-info');
    var p = lastOpened && products[lastOpened];
    if (!info || !p || $('.wv-buy', info)) return;
    var box = document.createElement('div');
    box.className = 'wv-buy-detail';
    box.innerHTML = '<span class="eyebrow">COMPRA ONLINE</span><strong>' + fmt(p.price) + '</strong>' +
      '<button type="button" class="button dark wv-buy" data-wv-buy="' + esc(lastOpened) + '"' + (p.available ? '' : ' disabled') + '>' +
      (p.available ? 'Comprar online <span>+</span>' : 'Agotado') + '</button>';
    var anchor = $('.detail-go-project', info);
    if (anchor) info.insertBefore(box, anchor); else info.appendChild(box);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wv-buy]');
    if (!btn) return;
    var p = products[btn.dataset.wvBuy];
    if (!p || !p.available) return;
    var qtyInput = btn.closest('dialog') && $('#detail-quantity');
    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = L('Añadiendo…', 'Adding…');
    api.add(p.variantId, qty).then(function () {
      btn.disabled = false;
      btn.innerHTML = label;
      var dialog = btn.closest('dialog');
      if (dialog && dialog !== drawer) dialog.close();
      openCart();
    }).catch(function (err) {
      btn.textContent = err && err.message ? err.message : 'No disponible';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 2400);
    });
  });

  var grid = $('#product-grid', root);
  if (grid) new MutationObserver(decorateCards).observe(grid, { childList: true, subtree: true });
  var detail = $('#product-detail-content', root);
  if (detail) new MutationObserver(decorateDialog).observe(detail, { childList: true });
  decorateCards();

  // Deep links: /#producto-<handle> (redirected product pages) and /?carrito=1 (redirected cart page)
  function openFromHash() {
    var m = /^#producto-(.+)$/.exec(location.hash);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var id = byHandle[handle] || handle;
    history.replaceState(null, '', location.pathname + location.search);
    var opener = $('[data-open-product="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]', root);
    if (opener) opener.click();
    else { var cat = $('#catalogo', root); if (cat) cat.scrollIntoView(); }
  }
  setTimeout(openFromHash, 300);

  var params = new URLSearchParams(location.search);
  if (params.get('carrito') === '1') {
    params.delete('carrito');
    var qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    setTimeout(openCart, 300);
  } else {
    refresh();
  }
})();
